import { render, staticRenderFns } from "./Kitchens.vue?vue&type=template&id=6c6b2b8e&"
import script from "./Kitchens.vue?vue&type=script&lang=js&"
export * from "./Kitchens.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports